
import React from "react";

import { FileDownloadFormat, GIFQualityOpt } from "./Constants";
import RadioSelector from "./RadioSelector";
import './ShareWidget.css';

interface ShareWidgetProps {
    gif_disabled: boolean;
    gif_quality: GIFQualityOpt;
    display_eswd_download_warning: boolean;
    onscreenshot: () => void;
    oncreategif: (quality: GIFQualityOpt) => void;
    onchangegifquality: (quality: GIFQualityOpt) => void;
    ondownloadfile: (format: FileDownloadFormat) => void;
}

class ShareWidget extends React.Component<ShareWidgetProps> {
    constructor(props: ShareWidgetProps) {
        super(props);

        this.onchangegifquality = this.onchangegifquality.bind(this);
    }

    onchangegifquality(quality: string) {
        this.props['onchangegifquality'](quality.toLowerCase() as GIFQualityOpt)
    }

    render() {
        const options = {
            'Low': !this.props['gif_disabled'],
            'Medium': !this.props['gif_disabled'],
            'High': !this.props['gif_disabled'],
        }
        return (
            <div id='share'>
                <div className='share-group'>
                    Images: 
                    <button onClick={this.props['onscreenshot']}>Take Screenshot</button>
                    <button 
                        onClick={() => this.props['oncreategif'](this.props['gif_quality'])} 
                        disabled={this.props['gif_disabled']}>
                        Make GIF
                    </button>

                    <RadioSelector
                        label_text='GIF Quality:'
                        options={options}
                        selected={this.props['gif_quality'].replace(/^[\w]/, c => c.toUpperCase())}
                        onchange={this.onchangegifquality}
                    />
                </div>
                <div className='share-group'>
                    Data:
                    <button onClick={() => this.props['ondownloadfile']('kml')}>Download KML</button>
                    <button onClick={() => this.props['ondownloadfile']('csv')}>Download CSV</button>
                    <button onClick={() => this.props['ondownloadfile']('geojson')}>Download GeoJSON</button>
                    <span className='eswd-warning' style={this.props['display_eswd_download_warning'] ? {}: {'visibility': 'hidden'}}>
                        ESWD data are not available for download
                    </span>
                </div>
            </div>
        );
    }
}

export default ShareWidget;